import { NgModule } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

import { MessageHtmlComponent } from './components/message-html/message-html.component';
import { MessageComponent } from './components/message/message.component';
import { AccessMessageComponent } from "./components/access-message/access-message.component";

import { LzMessageService } from './services/lz-message.service';

@NgModule({
  declarations: [
    MessageHtmlComponent,
    AccessMessageComponent,
    MessageComponent
  ],
  providers: [
    LzMessageService,
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogModule,
    NoopAnimationsModule,
    TranslateModule
  ],
  entryComponents: [
    MessageHtmlComponent,
    AccessMessageComponent,
    MessageComponent
  ]
})

export class LzMessageModule {

}
